import { HomeOutlined } from '@ant-design/icons';
import i18n from '../../utils/i18n.ts';

export const PAGES = {
  DISTRIBUTION_LISTS: 'DistributionList',
  EMAIL_TEMPLATE: 'EmailTemplate',
  ORGANIZATION_UNIT_LISTS: 'OrganizationUnitsList',
  TARGET_GROUPS: 'TargetGroup',
  TOPICS: 'Topic',
  USERS: 'UserEntra',
  REGULATIONS: 'Regulation',
} as const;

export const BREADCRUMBS = [
  {
    href: '/',
    title: <HomeOutlined />,
  },
  {
    href: '/',
    title: i18n.t('common.portal'),
  },
  {
    title: i18n.t('pages.admin.title'),
  },
];